import { isTriggerNode, type NodeModelWithId } from "@doitintl/cloudflow-commons";
import { type ReferencedNodeValue } from "@doitintl/cmp-models";

import { useVariableContext } from "../../../../Common/VariableProvider";
import { type NodeWitOutputModel } from "./useReferencedFieldContext";
import { createVariableMaps, getVariableValueFromReferencedField, isVariableReference } from "./utils/variableUtils";

export function useVariableReference(
  referencedNode: NodeWitOutputModel | undefined,
  value: ReferencedNodeValue | undefined
) {
  const { globalVariables, localVariables } = useVariableContext();
  const variableMaps = createVariableMaps(globalVariables, localVariables);

  if (!referencedNode) {
    return {
      isVariableRef: false,
      variableValue: "",
      variableMaps,
    };
  }

  const isVariableRef =
    value && isVariableReference(value.referencedField, isTriggerNode(referencedNode as unknown as NodeModelWithId));

  const variableValue = isVariableRef
    ? String(getVariableValueFromReferencedField(value.referencedField, variableMaps))
    : "";

  return {
    isVariableRef,
    variableValue,
    variableMaps,
  };
}
